import { styled } from '@linaria/react'
import { useTranslation } from 'react-i18next'
import useDimensions from '../../hooks/useDimensions'
import useBlazeSlider from '../../hooks/useBlazeSlider'
import { useNavigate } from '@tanstack/router'
import { useModal } from '@ebay/nice-modal-react'
import LoginModal from '../common/log-in-modal'
import { useBoundStore } from '../../store/store'
import { LazyLoadImage } from 'react-lazy-load-image-component'
import { Helmet } from 'react-helmet'
import banner_1 from '../../assets/home-v3/banner_1.webp'
import banner_1_pc from '../../assets/home-v3/banner_1_pc.webp'
import banner_2 from '../../assets/home-v3/banner_2.webp'
import banner_2_pc from '../../assets/home-v3/banner_2_pc.webp'
import banner_5 from '../../assets/home-v3/banner_5.webp'
import banner_5_pc from '../../assets/home-v3/banner_5_pc.webp'
import banner_6 from '../../assets/home-v3/banner_6.webp'
import banner_6_pc from '../../assets/home-v3/banner_6_pc.webp'
import banner_7 from '../../assets/home-v3/banner_7.webp'
import banner_7_pc from '../../assets/home-v3/banner_7_pc.webp'
import kyc_bonus from '../../assets/home-v3/50_bonus.webp'
import kyc_bonus_pc from '../../assets/home-v3/50_bonus_pc.webp'
import { CASINO_CATEGORIES } from '../../constants/casino'

const Img = styled(LazyLoadImage)`
  width: 100%;
  margin-bottom: -20px;
  aspect-ratio: 652 / 902;
  @media (min-width: 1200px) {
    margin-bottom: 0;
    aspect-ratio: 7680 / 2488;
  }
`

const Btn = styled.button`
  padding: 12px 0;
  background-color: var(--primary-btn-bg);
  border-radius: 6px;
  width: calc(100% - 24px);
  text-align: center;
  border-radius: 6px;
  margin: 0 auto 12px;
  display: block;
  p {
    font-size: 16px;
    color: var(--primary-btn-txt);
    text-transform: uppercase;
  }
  &.login {
    background-color: var(--highlight);
  }
  @media (min-width: 1200px) {
    position: absolute;
    width: 150px;
    bottom: 15%;
    right: 30%;
  }
`

const DotContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  bottom: 5%;
  right: 26px;
  z-index: 1;
  gap: 16px;
`

const Dot = styled.div<{ isActive: boolean }>`
  width: 9px;
  height: 9px;
  border-radius: 50%;
  transition: all 0.2s linear;
  cursor: pointer;
  border: 1px solid #fff;
  background-color: ${({ isActive }) => (isActive ? '#fff' : 'transparent')};
  &:last-child {
    margin-bottom: 0;
  }
`

const BANNERS = [
  {
    mobile: kyc_bonus,
    pc: kyc_bonus_pc,
    right: '48%',
    bottom: '9%',
  },
  {
    mobile: banner_6,
    pc: banner_6_pc,
    right: '42%',
    bottom: '9%',
  },
  {
    mobile: banner_7,
    pc: banner_7_pc,
    right: '32%',
    bottom: '9%',
  },
  {
    mobile: banner_1,
    pc: banner_1_pc,
    right: '30%',
  },
  {
    mobile: banner_2,
    pc: banner_2_pc,
    right: '40%',
  },
  {
    mobile: banner_5,
    pc: banner_5_pc,
    right: '48%',
  },
]

const Banner = () => {
  const navigate = useNavigate()
  const { t } = useTranslation('common')
  const { isDesktop } = useDimensions()
  const username = useBoundStore(state => state.user.username)
  const login = useModal(LoginModal)
  const { elRef, activeKey, slideTo } = useBlazeSlider({
    all: {
      enableAutoplay: true,
      slidesToShow: 1,
    },
  })

  return (
    <div style={{ position: 'relative' }}>
      {isDesktop && (
        <DotContainer>
          {BANNERS.map((_banner, key) => (
            <Dot
              key={key}
              isActive={key === activeKey}
              onClick={() => slideTo(key)}
            />
          ))}
        </DotContainer>
      )}
      <div className="blaze-slider" ref={elRef}>
        <div className="blaze-container">
          <div className="blaze-track-container">
            <div className="blaze-track">
              {BANNERS.map((banner, index) =>
                isDesktop ? (
                  <div style={{ position: 'relative' }} key={index}>
                     <Helmet>
                      <link rel="preload" as="image" href={banner.pc} />
                    </Helmet>
                    <Img src={banner.pc} alt="Banner" />
                    <Btn
                      style={{ right: banner.right, bottom: banner.bottom }}
                      onClick={() => {
                        if (username) {
                          navigate({
                            to: '/casino/$category',
                            params: { category: CASINO_CATEGORIES[0].label },
                          })
                        } else {
                          navigate({ to: '/register' })
                        }
                      }}>
                      <p>{username ? 'JUGAR AHORA' : t('register')}</p>
                    </Btn>
                  </div>
                ) : (
                  <div key={index}>
                    <Helmet>
                      <link rel="preload" as="image" href={banner.mobile} />
                    </Helmet>
                    <Img src={banner.mobile} alt="Banner" />
                    {username ? (
                      <Btn
                        onClick={() =>
                          navigate({
                            to: '/casino/$category',
                            params: { category: CASINO_CATEGORIES[0].label },
                          })
                        }>
                        <p>JUGAR AHORA</p>
                      </Btn>
                    ) : (
                      <>
                        <Btn onClick={() => navigate({ to: '/register' })}>
                          <p>{t('register')}</p>
                        </Btn>
                        <Btn className="login" onClick={() => login.show()}>
                          <p>{t('login')}</p>
                        </Btn>
                      </>
                    )}
                  </div>
                ),
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Banner
